import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { checkExistingActualTemplateFailed, checkExistingActualTemplateSuccessful } from '../actions';

export default function* checkExistingActualTemplate(action) {
  try {
    if (!action.payload) {
      throw new Error('Type not found');
    }
    const url = `${BACKEND_URL}/resources/notification-templates/check-existing-actual-template`;
    const response = yield makeRequest(url, { type: action.payload }, action, 'GET', true);
    const data = yield getBodyJson(response);
    if (response.status === OK) {
      yield put(checkExistingActualTemplateSuccessful());
      yield call(resolveActionPromise(action, data?.data));
    } else {
      yield put(checkExistingActualTemplateFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(checkExistingActualTemplateFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
